import { render, staticRenderFns } from "./SPCompanyRegistrationFinished.vue?vue&type=template&id=37c36900&scoped=true"
import script from "./SPCompanyRegistrationFinished.vue?vue&type=script&lang=js"
export * from "./SPCompanyRegistrationFinished.vue?vue&type=script&lang=js"
import style0 from "./SPCompanyRegistrationFinished.vue?vue&type=style&index=0&id=37c36900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c36900",
  null
  
)

export default component.exports